import './collage-slider.scss';
import Swiper from 'swiper/bundle';
export default () => {
    new Swiper('.js-collage-swiper', {
        slidesPerView: 1,
        spaceBetween: 15,
        centeredSlides: true,
        loop: true,
        speed: 40000, // Much slower transition speed (40 seconds)
        allowTouchMove: false,
        simulateTouch: false,
        autoplay: {
            delay: 0, // Continuous autoplay
            disableOnInteraction: false,
        },
        breakpoints: {
            1024: {
                spaceBetween: 40,
            },
        }
    });
};
